export interface IOptionType {
  id: number
  value: string | null
  visible: boolean
}

export const getOptionValues = (options: IOptionType[]): string[] =>
  options.filter((v) => v.visible).map((option) => option.value || '')
